import { Navigate, Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, ExternalLink } from "lucide-react";

export const AdminGuard = ({ children }) => {
  const token = localStorage.getItem("ylbh_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
};

const NAV = [
  { to: "/admin", label: "Konsultasi", end: true },
  { to: "/admin/artikel", label: "Artikel", end: false },
  { to: "/admin/tim", label: "Personalia", end: false },
  { to: "/admin/galeri", label: "Galeri", end: false },
  { to: "/admin/berita", label: "Berita", end: false },
  { to: "/admin/kasus", label: "Kasus", end: false },
  { to: "/admin/pengumuman", label: "Pengumuman", end: false },
];

export const AdminShell = ({ title, children }) => {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("ylbh_admin_token");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-ink text-foreground">
      <header className="sticky top-0 z-40 border-b border-white/10 bg-black/70 backdrop-blur-xl">
        <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-6">
          <div className="flex items-center gap-6">
            <img src="/logo-mark.png" alt="YLBH" className="h-8 w-auto" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
              {title}
            </span>
          </div>
          <nav className="flex items-center gap-5" aria-label="Navigasi admin">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`admin-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-[12px] font-medium uppercase tracking-[0.2em] transition-colors ${
                    isActive ? "text-gold" : "text-[#A3A3A3] hover:text-white"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/"
              data-testid="admin-lihat-situs"
              className="hidden items-center gap-1.5 text-[12px] font-medium uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors hover:text-white sm:flex"
            >
              <ExternalLink size={13} /> Situs
            </Link>
            <button
              onClick={logout}
              data-testid="admin-logout-button"
              className="flex items-center gap-1.5 border border-white/15 px-3 py-1.5 text-[12px] font-medium uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors hover:border-gold hover:text-gold"
            >
              <LogOut size={13} /> Keluar
            </button>
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-7xl px-6 py-10">{children}</main>
    </div>
  );
};
